import { PhotoIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import { FileUtils } from 'components/Utils/file';
import { classNames } from 'components/Utils/ui';
import React, { useState } from 'react';


const ImageDropper = ({ onFilesSelected = (files) => { }, isMultiple = true, maxFileSizeMb = 100 }) => {
    const [isDragging, setIsDragging] = useState(false);

    const onNewFiles = async (newFiles) => {
        for (const file of newFiles) {
            if (!FileUtils.checkFileSize(file, maxFileSizeMb)) {
                return;
            }
            if (!FileUtils.checkIsImage(file)) {
                alert('이미지 파일만 업로드 가능합니다.');
                return;
            }
            const hash = await FileUtils.getFileHash(file);
            file.hash = hash;
        }
        onFilesSelected(newFiles);
    };

    const handleClick = async () => {
        const files = await FileUtils.selectFiles(true, isMultiple);
        onNewFiles(files);
    }

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setIsDragging(false);
        const droppedFiles = Array.from(event.dataTransfer.files);
        onNewFiles(droppedFiles);
    };

    return (
        <div className={classNames("border border-dashed border-indigo-600 rounded-md cursor-pointer hover:bg-gray-50",
            isDragging ? 'bg-gray-50' : ''
        )}
            onClick={handleClick}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <div className="relative flex items-center justify-center size-40">
                <div className="absolute top-1 right-1">
                    <PlusCircleIcon className="size-6 text-indigo-600"></PlusCircleIcon>
                </div>
                <div>
                    <div className="relative items-center">
                        <PhotoIcon className="size-12 text-indigo-600" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImageDropper;